import { render } from "./resetPwd.vue?vue&type=template&id=0aadb0b5&scoped=true"
import script from "./resetPwd.vue?vue&type=script&lang=js"
export * from "./resetPwd.vue?vue&type=script&lang=js"

import "./resetPwd.vue?vue&type=style&index=0&id=0aadb0b5&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aadb0b5"]])

export default __exports__